import { useState, ChangeEvent, useEffect } from "react";

import MainLayout from "../layouts/MainLayout";
import PageTitle from '../components/UtilityHelpers/PageTitle';
import { Button, Modal, Datepicker, Label, Select, ToggleSwitch } from "flowbite-react";
import CustomThemeModal from '../components/CustomThemes/CustomThemeModal';

import { useNavigate } from 'react-router-dom';
import { useAuth } from "../hooks/useAuth";
import { useLoader } from "../hooks/useLoader";

import { RiBarChartBoxLine } from "react-icons/ri";

import ApiService from "../services/ApiServiceClass";

const ReportsPage = () => {
    const [openModal, setOpenModal] = useState(false);
    const auth = useAuth();
    const navigate = useNavigate();
    const loader = useLoader();

    const [column01, setColumn01] = useState(true);
    const [column02, setColumn02] = useState(true);
    const [column03, setColumn03] = useState(true);
    const [column04, setColumn04] = useState(true);
    const [column05, setColumn05] = useState(true);
    const [column06, setColumn06] = useState(true);
    const [column07, setColumn07] = useState(true);

    const [selectedFromDate, setSelectedFromDate] = useState<Date | null>(new Date(new Date().getFullYear(), 0, 1));
    const [selectedToDate, setSelectedToDate] = useState<Date | null>(new Date());
    const [selectedStatus, setSelectedStatus] = useState<string>("All");

    const handleFromDateChange = (date: Date | null) => {
        setSelectedFromDate(date);
    };

    const handleToDateChange = (date: Date | null) => {
        setSelectedToDate(date);        
    };

    const handleChangeSatus = (e: ChangeEvent<HTMLSelectElement>) => {
        setSelectedStatus(e.target.value);        
    }

    const handleOpenGenerateReportModal = () => {
        setOpenModal(true);
    }

    const handleSubmitGenerateReport = () => {
        if (!selectedFromDate || !selectedToDate) {
            console.error('Dates cannot be null');
            return;
        }

        const formData = new FormData();

        formData.append('selectedFromDate', selectedFromDate.toISOString());
        formData.append('selectedToDate', selectedToDate.toISOString());
        formData.append('selectedStatus', selectedStatus);
        formData.append('column01', column01.toString());
        formData.append('column02', column02.toString());
        formData.append('column03', column03.toString());
        formData.append('column04', column04.toString());
        formData.append('column05', column05.toString());
        formData.append('column06', column06.toString());
        formData.append('column07', column07.toString());

        loader?.setIsLoading(true);
        try {
            ApiService.generateReport(formData)
            .then(() => {                
                loader?.setIsLoading(false);
                setOpenModal(false);
            })
            .catch((error) => {
                console.log(error);
            });
        } catch(error) {
            loader?.setIsLoading(false);
            navigate("/login");
        }
    }

    return (
        <>
            <PageTitle title="OPS | Reports" />
            <MainLayout>
                
                <div className="col-span-12 rounded-sm border border-stroke bg-white px-5 pt-7.5 pb-5 shadow-default dark:border-strokedark dark:bg-boxdark sm:px-7.5 ">
                    <h5 className="text-xl font-semibold text-black dark:text-white mb-5">
                        Reports
                    </h5>

                    <div className="grid grid-cols-3 gap-4">

                        <div onClick={() => handleOpenGenerateReportModal()} className="cursor-pointer">
                            <div id="toast-success" className="flex items-center w-full max-w-xs p-4 mb-4 text-gray-500 bg-white rounded-lg shadow dark:text-gray-400 dark:bg-gray-800" role="alert">
                                <div className="inline-flex items-center justify-center flex-shrink-0 w-8 h-8 rounded-lg text-green-500 bg-green-100 dark:bg-green-800 dark:text-green-200">
                                    <RiBarChartBoxLine />
                                </div>
                                <div className="ms-3 text-sm font-normal">Generate Report</div>
                            </div>
                        </div>

                        <div onClick={() => navigate("/admin/reports/slip-chart")} className="cursor-pointer">
                            <div id="toast-success" className="flex items-center w-full max-w-xs p-4 mb-4 text-gray-500 bg-white rounded-lg shadow dark:text-gray-400 dark:bg-gray-800" role="alert">
                                <div className="inline-flex items-center justify-center flex-shrink-0 w-8 h-8 rounded-lg text-orange-500 bg-orange-100 dark:bg-orange-700 dark:text-orange-200">
                                    <RiBarChartBoxLine />
                                </div>
                                <div className="ms-3 text-sm font-normal">Slip Chart</div>
                            </div>
                        </div>

                    </div>


                    <Modal show={openModal} size="md" onClose={() => setOpenModal(false)} popup  theme={CustomThemeModal}>
                        <Modal.Header>
                            <div className="text-slate-600 ml-4 inline-flex items-center pt-1">
                                Select date interval to generate.
                            </div>                        
                        </Modal.Header>
                        <Modal.Body className="overflow-visible">
                            <div className="mt-2 mb-3 grid grid-cols-2 gap-4">
                                <div>
                                    <Label value="From" />
                                    <Datepicker 
                                        onSelectedDateChanged={(date) => handleFromDateChange(date)}
                                        defaultDate={new Date(new Date().getFullYear(), 0, 1)} 
                                    />
                                </div>                                
                                <div>
                                    <Label value="To" />
                                    <Datepicker 
                                        onSelectedDateChanged={(date) => handleToDateChange(date)}
                                    />
                                </div>                                                                
                            </div>
                            <div className="mt-2 mb-3">
                                <Label value="Select Status" />
                                <Select onChange={handleChangeSatus}>
                                    <option value="All">All</option>
                                    <option value="Delivered">Delivered</option>
                                    <option value="Ordered">Ordered</option>
                                    <option value="Purchased">Purchased</option>
                                    <option value="Approved">Approved</option>
                                    <option value="Waitlisted">Waitlisted</option>
                                    <option value="Declined">Declined</option>
                                    <option value="New">New</option>
                                </Select>
                            </div>
                            <div className="mt-2 mb-3">
                                <Label value="Select Columns" />
                                <div className="grid grid-cols-2 gap-2">
                                    <div>
                                        <ToggleSwitch className="mb-2" checked={column01} label="Category" onChange={setColumn01} />
                                        <ToggleSwitch className="mb-2" checked={column02} label="Type" onChange={setColumn02} />
                                        <ToggleSwitch className="mb-2" checked={column03} label="Description" onChange={setColumn03} />
                                        <ToggleSwitch className="mb-2" checked={column04} label="Title" onChange={setColumn04} />
                                    </div>
                                    <div>
                                        <ToggleSwitch className="mb-2" checked={column05} label="By" onChange={setColumn05} />
                                        <ToggleSwitch className="mb-2" checked={column06} label="Status" onChange={setColumn06} />
                                        <ToggleSwitch className="mb-2" checked={column07} label="TotalPrice" onChange={setColumn07} />
                                    </div>
                                </div>
                            </div>
                            <div className="mt-5 flex items-center justify-center">
                                <Button onClick={()=> handleSubmitGenerateReport()}>Generate & Download Excel</Button>
                            </div>
                        </Modal.Body>
                    </Modal>

                </div>

            </MainLayout>
        </>
    )
}

export default ReportsPage;